
import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FaqItem {
  question: string;
  answer: string;
}

const AdvisoryFaq = () => {
  const faqs: FaqItem[] = [
    {
      question: "Who leads the advisory sessions?",
      answer: "All sessions are led by experienced DocketLabs consultants who specialize in legal industry AI applications, strategic planning, and risk management. You'll work directly with our experts who understand both the technical landscape and the realities of practicing law."
    },
    {
      question: "What if we don't know exactly what we need yet?",
      answer: "That's completely normal — and exactly why we offer a free advisory session. During our conversation, we'll help you clarify your goals, identify practical opportunities, and recommend realistic next steps based on your firm's needs — with no obligation."
    },
    {
      question: "Can we switch from hourly to a retainer later?",
      answer: "Yes. Many firms start with a one-hour session and then transition to a monthly advisory relationship once they see the value. We'll recommend the right level of support as your needs evolve."
    },
    {
      question: "What happens after the free advisory session?",
      answer: "After your session, you'll receive a clear summary of key insights, opportunities, and suggested next steps. If it makes sense for your firm, we'll discuss options for continued support — whether that's a focused advisory session, enrollment in targeted training modules, or building a full AI strategy roadmap. The next move is always yours."
    }
  ];
  
  return (
    <section className="py-16 md:py-24 bg-white/5 border-t border-white/10">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center">
            Frequently Asked Questions
          </h2>
          
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border-b border-white/10">
                <AccordionTrigger className="text-lg font-medium">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-white/80">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default AdvisoryFaq;
